const TASK_DRAFT_KEY = 'mozayc_task_draft';
const EVENT_DRAFT_KEY = 'mozayc_event_draft';
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

export interface TaskDraftData {
  title: string;
  notes: string;
  columnId: string;
  dueDate: string;
  dueTime: string;
  tagId: string | null;
  assigneeId: string | null;
  priority: 'none' | 'low' | 'medium' | 'high';
  dateEnabled: boolean;
  timeEnabled: boolean;
  categoryEnabled: boolean;
  priorityEnabled: boolean;
  assigneeEnabled: boolean;
}

export interface EventDraftData {
  title: string;
  notes: string;
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
  tagId: string | null;
  allDay: boolean;
  fullSize: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  recurrenceRule: any;
}

function save(key: string, data: unknown) {
  try {
    localStorage.setItem(key, JSON.stringify({ data, savedAt: Date.now() }));
  } catch { /* ignore quota errors */ }
}

function load<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { data: T; savedAt: number };
    if (Date.now() - parsed.savedAt > MAX_AGE_MS) {
      localStorage.removeItem(key);
      return null;
    }
    return parsed.data;
  } catch {
    return null;
  }
}

function clear(key: string) {
  try { localStorage.removeItem(key); } catch { /* ignore */ }
}

function notify() {
  window.dispatchEvent(new Event('mozayc:draft-changed'));
}

export const saveTaskDraft = (data: TaskDraftData) => { save(TASK_DRAFT_KEY, data); notify(); };
export const loadTaskDraft = () => load<TaskDraftData>(TASK_DRAFT_KEY);
export const clearTaskDraft = () => { clear(TASK_DRAFT_KEY); notify(); };

export const saveEventDraft = (data: EventDraftData) => { save(EVENT_DRAFT_KEY, data); notify(); };
export const loadEventDraft = () => load<EventDraftData>(EVENT_DRAFT_KEY);
export const clearEventDraft = () => { clear(EVENT_DRAFT_KEY); notify(); };
